












































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import ShiftForm from './ShiftForm/ShiftForm.vue'
import ShiftVDP from './ShiftVDP/ShiftVDP.vue'
import ShiftAtom from './ShiftAtom/ShiftAtom.vue'
import ShiftAtomCoockPlan from './ShiftAtomCoockPlan/ShiftAtomCoockPlan.vue'
import ShiftAtomJournal from './ShiftAtomJournal/ShiftAtomJournal.vue'
import ShiftOneCExport from './ShiftOneCExport/ShiftOneCExport.vue'
import ShiftVDPFact from './ShiftVDPFact/ShiftVDPFact.vue'
import ShiftVDPSouffling from './ShiftVDPSouffling/ShiftVDPSouffling.vue'
import ShiftAtomSouffling from './ShiftAtomSouffling/ShiftAtomSouffling.vue'
import ShiftAtomFact from './ShiftAtomFact/ShiftAtomFact.vue'
import ShiftAtomSoufflingBottling from './ShiftAtomSoufflingBottling/ShiftAtomSoufflingBottling.vue'
import ShiftVDPJournal from './ShiftVDPJournal/ShiftVDPJournal.vue'
import ShiftClose from './ShiftClose.vue'
import ShiftWorkers from './ShiftWorkers/ShiftWorkers.vue'
import ShiftClots from './ShiftClots/ShiftClots.vue'
import ShiftAtomCheckList from './ShiftAtomCheckList/ShiftAtomCheckList.vue'
import ShiftAtomLaboratory from './ShiftAtomLaboratory/ShiftAtomLaboratory.vue'
import ShiftVDPLaboratory from './ShiftVDPLaboratory/ShiftVDPLaboratory.vue'
import ShiftVDPIngredients from "@/modules/ShiftDetails/ShiftVDPIngredients/ShiftVDPIngredients.vue";
import ShiftCustomPlan from "@/modules/ShiftDetails/ShiftCustomPlan/ShiftCustomPlan.vue";
import ShiftCustomFact from "@/modules/ShiftDetails/ShiftCustomFact/ShiftCustomFact.vue";
import ShiftCustomPlanSemi from "@/modules/ShiftDetails/ShiftCustomPlanSemi/ShiftCustomPlanSemi.vue";
import ShiftCustomFactSemi from "@/modules/ShiftDetails/ShiftCustomFactSemi/ShiftCustomFactSemi.vue";
import ShiftCustomSouffling from "@/modules/ShiftDetails/ShiftCustomSouffling/ShiftCustomSouffling.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter', 'remains', 'workers',

      'document', 'meta', 'notifications'
    ]),
    ...mapGetters(STORE_KEY, [
      'hasActions', 'canActionToWork', 'canActionConfirmAction', 'disableActionConfirmActionCall', 'canActionToFormation',
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, ['toWork', 'toFormation', 'confirmBasket', 'loadRemains'])
  },
  components: {
    ShiftForm,
    ShiftVDP,
    ShiftAtom,
    ShiftAtomCoockPlan,
    ShiftAtomJournal,
    ShiftOneCExport,
    ShiftAtomCheckList,
    ShiftVDPFact,
    ShiftVDPSouffling,
    ShiftAtomSouffling,
    ShiftAtomSoufflingBottling,
    ShiftVDPJournal,
    ShiftWorkers,
    ShiftClots,
    ShiftAtomFact,
    ShiftAtomLaboratory,
    ShiftVDPLaboratory,
    ShiftVDPIngredients,
    ShiftCustomPlan,
    ShiftCustomFact,
    ShiftCustomPlanSemi,
    ShiftCustomFactSemi,
    ShiftCustomSouffling,
  }
})
export default class ShiftDetails extends Vue {

  @Prop() params!: any

  public TAB_VIEW_DETAILS = 0;
  public TAB_VIEW_FORM = 1;
  public TAB_VIEW_STATISTIC = 2;

  hActiveTab: number | null = null;

  get activeTab() {
    return this.hActiveTab ? this.hActiveTab : (this.isNew ? this.TAB_VIEW_FORM : this.TAB_VIEW_DETAILS);
  }

  set activeTab(value: number) {
    this.hActiveTab = value
  }

  public activeDetailTab = 0;

  get config() {
    return this.params || this.$route.params || {}
  }

  get isModal() {
    return this.params
  }

  get isNew() {
    return this.config.id == 'new'
  }

  get allowClose() {
    // @ts-ignore
    return this.document.real_begin_time && !this.document.real_end_time
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public setTimer(worker: any, $event: boolean) {
    worker.is_timer_start = $event;
    this.$store.dispatch(`${STORE_KEY}/setTimer`, worker);
  }

  public startShift() {
    this.$store.dispatch(`${STORE_KEY}/startShift`);
  }

  public stopShift() {
    this.$buefy.modal.open({
      component: ShiftClose,
      props: {
      },
      events: {
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  public mounted() {
    console.log('details mounted', this.config)
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
    this.activeDetailTab = this.$route.query.tab ? parseInt(this.$route.query.tab as any) : 0
  }

  public loadDocumentData(nV?: any, oV?: any) {
    if(!this.isModal || this.config.inline) {
      this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
    }
  }

  @Watch('config.id')
  public reloadDocumentData(nV?: any, oV?: any) {
    console.log('123')
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
  }

  onNeedDataReload(documentId: string) {
    if (!this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/loadData`, {
        ...this.config,
        silence: true
      });
      this.hActiveTab = this.TAB_VIEW_DETAILS
    } else {
      this.$router.replace({
        name: 'shift-details',
        params: {
          id: documentId
        }
      })
    }
  }

  onTab(tab: number) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        // @ts-ignore
        tab,
      }
    })  
  }

  public goBack() {
    if (!this.params) {
      this.$router.push({ name: 'shifts' });
    } else {
      this.$router.back();
      this.$emit('close');
    }
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }

}
